// 学校ごとのガイダンスの回答方法。学生アプリの guidance_config.dart と同じ考え方。
//   ・志望群（既定）: 第1志望群を3つ・第2志望群を3つ選ぶ。いいねは6個以上。
//   ・順位付け（rankCount > 0）: 第1志望〜第rankCount志望まで順番をつける。いいねは rankCount 個以上。
//     例: ユニバーサル美容専門学校は8、YICビューティモード専門学校は6（info/guidance の mode: 'rank', rankCount と合わせる）
// Web のガイダンスはログインしないので info/guidance を読めない。App.js のルートで rankCount を渡す。
// 順位は status に「1位」〜「8位」として保存し（アプリと同じ）、画面には「第1志望」〜と出す。

export const minLikesOf = (rankCount: number) => (rankCount > 0 ? rankCount : 6);

export const rankLabel = (rank: number) => `${rank}位`;
export const rankDisplay = (rank: number) => `第${rank}志望`;
